import AplicarLegenda from "./AplicarLegenda";

export default AplicarLegenda;